var _a;
import VisibilityTrackingPlugin from '@spt-tracking/engage-visibility-tracking-plugin';
import { buildClickUIElementEvent } from './click/ui-element/event-builder.js';
import { pageFromPageView } from './utils/page-from-page-view.js';
import { buildViewArticleEvent } from './view/article/event-builder.js';
import { buildViewFrontpageEvent } from './view/frontpage/event-builder.js';
import { buildViewListingEvent } from './view/listing/event-builder.js';
import { buildViewLoginPosterEvent } from './view/loginposter/event-builder.js';
import { buildViewPageEvent } from './view/page/event-builder.js';
import { buildViewSalesPosterEvent } from './view/salesposter/event-builder.js';
import { buildViewUIElementWithPluginEvent } from './view/ui-element/engage-visibility-tracking-plugin/event-builder.js';
import { buildViewUIElementEvent } from './view/ui-element/event-builder.js';
class NewsMediaPulseTracker {
    constructor(pulseTracker) {
        this.currentPage = {
            id: 'undefined-id',
            type: 'Page',
            url: typeof window !== 'undefined' ? window.location.href : '',
        };
        this.updateBaseEvent = (eventProperties, mergeWithPreviousState = true) => this.pulseTracker.update(eventProperties, mergeWithPreviousState);
        this.trackViewArticle = (inputProperties, trackOptions) => {
            const pageViewEventData = buildViewArticleEvent(inputProperties);
            this.currentPage = pageFromPageView(pageViewEventData);
            return this.pulseTracker.trackPageView(pageViewEventData, trackOptions);
        };
        this.trackViewLoginPoster = (inputProperties, trackOptions) => {
            const pageViewEventData = buildViewLoginPosterEvent(inputProperties);
            this.currentPage = pageFromPageView(pageViewEventData);
            return this.pulseTracker.trackPageView(pageViewEventData, trackOptions);
        };
        this.trackViewSalesPoster = (inputProperties, trackOptions) => {
            const viewSalesposterEventData = buildViewSalesPosterEvent(inputProperties);
            this.currentPage = pageFromPageView(viewSalesposterEventData);
            return this.pulseTracker.trackPageView(viewSalesposterEventData, trackOptions);
        };
        this.trackViewListing = (inputProperties, trackOptions) => {
            const viewListingEventData = buildViewListingEvent(inputProperties);
            this.currentPage = pageFromPageView(viewListingEventData);
            return this.pulseTracker.trackPageView(viewListingEventData, trackOptions);
        };
        this.trackViewFrontpage = (inputProperties, trackOptions) => {
            const viewFrontpageEventData = buildViewFrontpageEvent(inputProperties);
            this.currentPage = pageFromPageView(viewFrontpageEventData);
            return this.pulseTracker.trackPageView(viewFrontpageEventData, trackOptions);
        };
        this.trackViewPage = (inputProperties, trackOptions) => {
            const pageViewEventData = buildViewPageEvent(inputProperties);
            this.currentPage = pageFromPageView(pageViewEventData);
            return this.pulseTracker.trackPageView(pageViewEventData, trackOptions);
        };
        this.addPageLeaveTracking = (objectElement, pageElement, eventBuilder, options) => this.pulseTracker.addPageLeaveTracking(objectElement, pageElement, eventBuilder, options);
        this.removePageLeaveTracking = () => this.pulseTracker.removePageLeaveTracking();
        this.updatePageLeaveTracking = (objectElement, pageElement, resetProperties) => this.pulseTracker.updatePageLeaveTracking(objectElement, pageElement, resetProperties);
        this.trackPageLeave = (eventInput, eventName) => this.pulseTracker.trackPageLeave(eventInput, eventName);
        this.trackActivePageLeave = (eventInput, eventName) => this.pulseTracker.trackActivePageLeave(eventInput, eventName);
        this.trackViewUIElement = (inputProperties, trackOptions) => {
            const viewUIElementEventData = buildViewUIElementEvent(inputProperties, this.currentPage);
            return this.pulseTracker.track('trackerEvent', viewUIElementEventData, trackOptions);
        };
        this.registerViewUIElementTracking = (pluginConfig) => {
            const updatedBaseEvent = buildViewUIElementWithPluginEvent(pluginConfig.event || {}, this.currentPage);
            const visibilityTracker = new VisibilityTrackingPlugin(this.pulseTracker, {
                ...pluginConfig,
                event: updatedBaseEvent,
            });
            visibilityTracker.start();
        };
        this.trackClickUIElement = (inputProperties, trackOptions) => {
            const clickUIElementEventData = buildClickUIElementEvent(inputProperties, this.currentPage);
            return this.pulseTracker.track('trackerEvent', clickUIElementEventData, trackOptions);
        };
        this.pulseTracker = pulseTracker;
    }
}
_a = NewsMediaPulseTracker;
NewsMediaPulseTracker.fromPulseTracker = (PulseTrackerClass, trackerConfig) => {
    const { providerId, productName, deployStage, builders = {}, sdkConfigInput = {}, } = trackerConfig;
    const sdkConfig = {
        deployStage,
        ...sdkConfigInput,
    };
    const pulseTracker = new PulseTrackerClass(providerId, sdkConfig, builders);
    pulseTracker.update({
        provider: {
            id: providerId,
            product: productName,
            productType: 'ResponsiveWeb',
        },
    });
    return new _a(pulseTracker);
};
NewsMediaPulseTracker.fromAutotracker = async (pulseAutotracker, trackerConfig, trackerId) => {
    const { providerId, productName, deployStage, builders = {}, sdkConfigInput = {}, } = trackerConfig;
    const sdkConfig = {
        deployStage,
        ...sdkConfigInput,
    };
    pulseAutotracker('init', providerId, sdkConfig, builders, trackerId);
    return new Promise((resolve, reject) => {
        const handleTracker = (pulseTracker) => {
            if (pulseTracker) {
                pulseTracker.update({
                    provider: {
                        id: providerId,
                        product: productName,
                        productType: 'ResponsiveWeb',
                    },
                });
                resolve(new _a(pulseTracker));
            }
            else {
                reject(new Error('Error getting pulse tracker'));
            }
        };
        if (trackerId) {
            pulseAutotracker(trackerId, handleTracker);
        }
        else {
            pulseAutotracker(handleTracker);
        }
    });
};
export { NewsMediaPulseTracker };
//# sourceMappingURL=NewsMediaPulseTracker.js.map